import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar-buyer-payer',
  templateUrl: './progress-bar-buyer-payer.component.html',
  styleUrls: ['./progress-bar-buyer-payer.component.scss']
})
export class ProgressBarBuyerPayerComponent implements OnInit {
  @Input() active?: any;
  steps = [
      'Αποδοχή Αίτησης',
      'Εξόφληση Τελών Κτηματολογίου',
      'Παρακολούθηση Υποβληθείσας Αίτησης',
  ];
  constructor() {}

  ngOnInit(): void {
      if (!this.active) {
          this.active = 4;
      }
  }
}
